import {Playground} from "../../components/playground/types";
import {createContext, useContext} from "react";

export const PlaygroundContext = createContext<Playground | null>(null);

export function usePlayground(): Playground {
    const context = useContext(PlaygroundContext);
    if (!context) {
        throw new Error("usePlayground must be used within a PlaygroundContextProvider");
    }

    return context;
}
